import React from "react";
import _ from "lodash";
import Input from "Components/input/Input";
import Button from "Components/button/Button";
import ButtonIcon from "Components/buttonIcon/ButtonIcon";
import HelpTooltip from "Components/helpTooltip/HelpTooltip";
import { t } from "i18next";

import { plus, trash } from "Icons/index";

import cx from "classnames";
// import s from "../allowNets/allowNets.scss";
import s from "./repeater.scss";

export default class Repeater extends React.Component {
  constructor(props) {
    super(props);
    this.updateInput = this.updateInput.bind(this);

    this.state = {
      inputValue: ""
    };
  }

  updateInput(v) {
    this.setState({
      inputValue: v.repeater
    });
  }

  add() {
    const { disabled, maxValues, values, validateNewValue } = this.props;
    if (disabled) {
      return false;
    }

    if (maxValues && Object.keys(values).length === maxValues) {
      window.alert(`Hai raggiunto il massimo numero di valori consentiti (${maxValues})`);
      return false;
    }

    const element = this.input;
    let newValue = this.state.inputValue;
    if (newValue) newValue = newValue.trim();

    if (validateNewValue && validateNewValue(newValue)) {
      element.value = "";
      const updatedValues = [...values, newValue];
      this.updateValue(updatedValues);
    }

    this.setState({ inputValue: "" });
  }

  remove(e) {
    const { values } = this.props;

    let updatedValues = [...values];
    const valueToRemove = e.currentTarget.closest("." + s.contentRow).id;

    _.remove(updatedValues, value => value === valueToRemove);
    this.updateValue(updatedValues);
  }

  updateValue(newValue) {
    this.props.onChange({ [this.props.name]: newValue });
  }

  enterPressed(e) {
    if (e.which === 13) {
      e.preventDefault();
      e.stopPropagation();
      this.add();
    }
  }

  focus() {
    this.input.focus();
  }

  render() {
    const {
      className,
      errors,
      disabled,
      label,
      labelInput,
      name,
      hint,
      values,
      placeholder,
      buttonText,
      helpMsg
    } = this.props;
    let content = <div className={s.emptyList} />;

    if (values && Object.keys(values).length > 0) {
      content = _.map(values, ip => (
        <div className={s.contentRow} key={ip} id={ip}>
          <div className={s.infoRow}>{ip}</div>
          <div className={s.actionsRow}>
            <ButtonIcon icon={trash} onClick={this.remove.bind(this)} />
          </div>
        </div>
      ));
    }

    return (
      <div className={cx(className, s.repeater)}>
        <div className={s.wrapInput}>
          <Input
            className={s.input}
            label={labelInput}
            name="repeater"
            type="text"
            ref={el => (this.input = el)}
            placeholder={placeholder}
            onKeyDown={this.enterPressed.bind(this)}
            disabled={disabled}
            errors={errors}
            onChange={this.updateInput}
            value={this.state.inputValue}
            helpTooltip={
              helpMsg && (
                <HelpTooltip
                  children={[
                    {
                      description: helpMsg
                    }
                  ]}
                />
              )
            }
          />
          <Button
            className={s.addBtn}
            icon={plus}
            color="accent"
            type="button"
            onClick={this.add.bind(this)}
            onlyIcon
          />
        </div>
        {hint && <div className={s.hint}>{hint}</div>}

        <div className={s.wrapList}>
          <div htmlFor={name} className={s.headerList}>
            {label}
          </div>

          <div className={s.contentList}>{content}</div>
        </div>
      </div>

      /*
      <div className={cx(s.InputWithLabel)}>
        <label
          htmlFor={name}
          className={cx(s.label, { [s.labelWithHint]: hint, [s.labelWithErrors]: errors })}
        >
          {label || name.replace("_", " ")}
        </label>

        <ul className={s.repeaterContainer}>{content}</ul>
        <div className={cx(s.newEntry)}>
          <input
            type="text"
            ref={el => (this.input = el)}
            placeholder={placeholder}
            onKeyDown={this.enterPressed.bind(this)}
            disabled={disabled}
            className={cx(s.input, { [s.InputWithErrors]: errors, [s.disabled]: disabled })}
          />
          <button className={cx(s.addButton)} type="button" onClick={this.add.bind(this)}>
            <b>{buttonText || <TranslatedString>action.add</TranslatedString>}</b>
          </button>
        </div>
        {errors && <span className={cx(s.errorMsg)}>{errors}</span>}
      </div>*/
    );
  }
}
